export const PlaceHolder = {
  AMMOUNT: "0,000,00",
  DATE: "DD-MM-YYYY",
  INTEREST_RATE: "0%",
};
